<template>
  <v-progress-linear :value="objectifEnPourcentage" height="55" stream rounded color="grey lighten-2" background-color="white" class="mb-2">
    <strong class="primary--text"><v-icon class="mr-1" color="primary">mdi-bullseye-arrow</v-icon> {{ amasse }} $ / {{ objectif }} $</strong>
  </v-progress-linear>
</template>

<script>
export default {
  props: {
    amasse: Number,
    objectif: Number
  },
  computed: {
    objectifEnPourcentage() {
      return (this.amasse * 100) / this.objectif
    },
    colorObjectif() {
      return this.objectifAtteint ? "success" : "info lighten-1"
    },
    objectifAtteint() {
      return this.objectifEnPourcentage >= 100
    }
  }
}
</script>

<style>
</style>